var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"sellers mt-3 px-4",staticStyle:{"min-height":"100vh"}},[(_vm.profile && _vm.profile.name)?_c('div',[_c('SellersHeader'),_c('SellerList')],1):_c('div',{staticClass:"ma-2"},[_c('Loader')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }